var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticClass:"select-fabric",attrs:{"options":_vm.fabrics,"value":_vm.modelValue,"multiple":true,"label":"production_name","closeOnSelect":false,"reduce":(option) => option.id,"placeholder":"Select Fabrics"},on:{"input":_vm.setFabric}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }